"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.link");
var _versionUpdate = require("@/api/versionUpdate");
var _validate = require("@/utils/validate");
var _appBasicSetup = require("@/api/appBasicSetup");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      specialBoole: false,
      updateBoole: false,
      templateList: [],
      ruleForm: {
        inviteConfig: '',
        title: '',
        main: '',
        osType: '',
        versionCode: '',
        link: '',
        forceBoole: false,
        onlineBoole: false,
        examineBoole: false,
        invite: '',
        iosLink: '',
        pageCode: ''
      },
      rules: {
        title: [],
        inviteConfig: [{
          required: true,
          message: '请选择邀请码功能设置',
          trigger: 'change'
        }],
        invite: [{
          required: true,
          message: '请选择邀请码功能设置',
          trigger: 'change'
        }],
        main: [{
          required: true,
          message: '请输入更新内容',
          trigger: 'blur'
        }],
        osType: [{
          required: true
        }],
        versionCode: [{
          required: true,
          message: '请输入版本号 ',
          trigger: 'blur'
        }],
        link: [{
          required: true,
          message: '请输入下载链接 ',
          trigger: 'blur'
        }],
        iosLink: [{
          required: true,
          message: '请输入AppStore下载链接 ',
          trigger: 'blur'
        }],
        forceBoole: [],
        onlineBoole: [],
        examineBoole: []
      },
      dialogVisible: false,
      releaseId: ''
    };
  },
  methods: {
    submitForm: (0, _validate.throttle)(function (formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          (0, _versionUpdate.updateRelease)({
            inviteConfig: _this.ruleForm.inviteConfig,
            releaseId: _this.releaseId,
            title: _this.ruleForm.title,
            content: _this.ruleForm.main,
            os: _this.ruleForm.osType,
            version: _this.ruleForm.versionCode,
            link: _this.ruleForm.osType === 0 ? _this.ruleForm.link : _this.ruleForm.iosLink,
            forceUpdate: _this.ruleForm.forceBoole ? 1 : 0,
            online: _this.ruleForm.onlineBoole ? 1 : 0,
            audit: _this.ruleForm.examineBoole ? 1 : 0,
            auditInvite: _this.ruleForm.invite,
            pageCode: _this.ruleForm.pageCode
          }).then(function (res) {
            if (res.data) {
              _this.$notify.success({
                title: '温馨提示',
                message: '操作成功！'
              });
              _this.onClose();
              _this.$emit('success');
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }, 3000),
    // submitForm(formName) {
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       updateRelease({
    //         releaseId: this.releaseId,
    //         title: this.ruleForm.title,
    //         content: this.ruleForm.main,
    //         os: this.ruleForm.osType,
    //         version: this.ruleForm.versionCode,
    //         link: this.ruleForm.osType === 0 ? this.ruleForm.link : this.ruleForm.iosLink,
    //         forceUpdate: this.ruleForm.forceBoole ? 1 : 0,
    //         online: this.ruleForm.onlineBoole ? 1 : 0,
    //         audit: this.ruleForm.examineBoole ? 1 : 0,
    //         auditInvite: this.ruleForm.invite
    //       }).then(res => {
    //         if (res.data) {
    //           this.$notify.success({
    //             title: '温馨提示',
    //             message: '操作成功！'
    //           })
    //           this.onClose()
    //           this.$emit('success')
    //         }
    //       })
    //     } else {
    //       console.log('error submit!!')
    //       return false
    //     }
    //   })
    // },
    changeOsType: function changeOsType() {
      this.$refs.ruleForm12.validateField('link');
      this.$refs.ruleForm12.validateField('iosLink');
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    open: function open(val) {
      this.releaseId = val.releaseId;
      this.ruleForm.title = val.title;
      this.ruleForm.inviteConfig = val.inviteConfig;
      this.ruleForm.main = val.content;
      this.ruleForm.osType = val.os;
      this.ruleForm.versionCode = val.version;
      if (this.ruleForm.osType === 0) {
        this.ruleForm.link = val.link;
      } else {
        this.ruleForm.iosLink = val.link;
      }
      this.ruleForm.forceBoole = val.forceUpdate * 1 === 1;
      this.ruleForm.onlineBoole = val.online * 1 === 1;
      this.ruleForm.examineBoole = val.audit * 1 === 1;
      this.ruleForm.invite = val.auditInvite;
      this.ruleForm.pageCode = val.pageCode;
      this.specialBoole = val.online * 1 === 1;
      this.dialogVisible = true;
      this.queryHomepageTemplateSelect();
    },
    queryHomepageTemplateSelect: function queryHomepageTemplateSelect() {
      var _this2 = this;
      (0, _appBasicSetup.queryHomepageTemplateSelect)().then(function (res) {
        _this2.templateList = res.data || [];
      });
    },
    onClose: function onClose() {
      this.releaseId = '';
      this.dialogVisible = false;
      this.updateBoole = false;
      this.resetForm('ruleForm12');
    }
  }
};